export default __webpack_public_path__ + "b9d606034e4344498d142ce79c914faa.svg";